import { Injectable } from '@angular/core';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
import { TipusVehiclesFilter } from '../models/tipus-vehicles-filter';

const defaultSortParam = 'descripcio';
const defaultSortDirection = 'asc';

@Injectable()
export class TipusVehiclesFilterService extends CustomFilterService {
  public createFilterParams(filter: TipusVehiclesFilter, start: number, pageSize: number, sortField: string, sortDir: string ) {

    return new HttpParams()
    .append('id', (filter.id ? filter.id.toString() : ''))
    .append('descripcio', filter.descripcio)
    .append('matriculaObligatoria', this.getTristateValue(filter.matriculaObligatoria))
    .append('start', start.toString())
    .append('size', pageSize.toString())
    .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
    .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
  }
}
